module.exports = __webpack_public_path__ + "img/jack-o-lantern.85980b6f.png";